import { getRecentAlerts } from '@/services/alerts';
import { getDateFormatted } from '@/utils/index';

function updateCardCounter(key, value, cardCounter) {
  cardCounter[key] += value;
}

export const actions = {
  async loadRecentAlerts({ rootGetters, commit }, params) {
    const token = rootGetters['user/getToken'];

    const response = await getRecentAlerts(token.access, params);
    let listAlerts = [];
    let cardCounter = {
      Ambiência: 0,
      Sanidade: 0,
      Desempenho: 0,
      Nutrição: 0,
    };
    let alertCards = [];
    let totalAlerts = 0;
    if (response?.length) {
      response.forEach((element, index) => {
        totalAlerts++;
        updateCardCounter(element.type, 1, cardCounter);
        listAlerts.push({
          'key': index,
          'shedPropertyName': element.shed_property_name,
          'shedCore': element.shed_core,
          'shedIdentification': element.shed_identification,
          'propertyOwner': element.shed_property_owner,
          'batchIdentification': element.batch_identification,
          'breedingType': element.batch_breeding_type,
          'age': element.age,
          'type': element.type,
          'subtype': element.subtype,
          'message': element.message,
          'timestamp': getDateFormatted(element.timestamp),
        });
      });
    }

    function cardColorPick(cardCounter) {
      if (cardCounter > 0) return 3;
      else return 0;
    }

    Object.entries(cardCounter).forEach((card, index) => {
      alertCards.push({
        'alert': cardColorPick(card[1]),
        'alertIndex': index,
        'name': card[0],
        'value': card[1],
      });
    });
    commit('SET_ALERTS', listAlerts);
    commit('SET_ALERT_CARDS', alertCards);
    commit('SET_TOTAL_ALERTS', response.count);
    commit('SET_SHOW_ALERT_CARDS', true);
    commit('SET_ALERTS_IS_LOADED', true);
  },
};
